module.exports = __webpack_public_path__ + "static/media/clerky.d398c9a6.jpg";